var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataInvoiceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D253C",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 1h26.626v35.129H1V1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.82 5.777h20.942Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeWidth: 2,
    d: "M3.82 5.777h20.942"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M3.82 8.47h20.942M3.82 11.615h20.942M3.82 14.534h20.942M3.82 17.453h20.942M3.82 20.371h20.942M3.82 23.29h20.942M3.82 26.209h20.942M3.82 29.354h7.479M3.82 32.047h7.479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataInvoiceIcon);
export default __webpack_public_path__ + "static/media/data-invoice-icon.735286071cce16788357afb44233d296.svg";
export { ForwardRef as ReactComponent };